/**
 * @generated SignedSource<<30ef410b078961ea01bc83dfef2d6e09>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions$data = {
  readonly id: string;
  readonly key: string;
  readonly " $fragmentType": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions";
};
export type removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions$key = {
  readonly " $data"?: removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions$data;
  readonly " $fragmentSpreads": FragmentRefs<"removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "key"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "bf7da4aac2b6cd1fbe625288d4086691";

export default node;
